export default "__VITE_ASSET___49DY1Z0__"